import React from "react";
import { RiCheckboxMultipleBlankFill } from "react-icons/ri";
import { FaHandshake } from "react-icons/fa6";
import { FaRegHandPointRight } from "react-icons/fa6";
import { IoPeopleSharp } from "react-icons/io5";



export const OurValues = () => {
  return (
    <div className="ourValuesContainer">
      <div className="container">
        <div className="ourValueGrid">
          <div className="ourValueLeft">
            <div className="ourTitle">Our Values</div>
            <div className="ourDesc">
              At SnapBid, our values aren’t just principles — they’re the
              foundation of everything we build. From the moment you land on our
              platform to the final offline bid, we’re committed to creating an
              experience that’s transparent, trustworthy, and genuinely
              buyer-first. We believe in removing pressure, simplifying
              decisions, and giving every user the clarity and control they
              deserve while navigating one of life’s biggest investments.
            </div>
          </div>
          <div className="ourValueRight">
            <div className="ourValueRight-Content">
              <div
                className="ourValueRight-Grid ourValue-borderbottom"
                // style={{ borderBottom: "1px solid #DADADA" }}
              >
                <div
                  className="ourValueCard"
                  style={{ borderRight: "1px solid #DADADA"}}
                >
                  <div className="valueIconContainer">
                    <span className="valueIcon">
                      <RiCheckboxMultipleBlankFill />
                    </span>
                    <span className="valueCardTitle">Transparency</span>
                  </div>
                  <div className="valueCardDesc">
                    Every property and process is open and honest. No hidden
                    details, no surprises.
                  </div>
                </div>
                <div className="ourValueCard">
                  <div className="valueIconContainer">
                    <span className="valueIcon">
                    <FaHandshake />

                    </span>
                    <span className="valueCardTitle">Trust First</span>
                  </div>
                  <div className="valueCardDesc">
                    We prioritize genuine interactions and verified listings
                    over flashy sales tactics.
                  </div>
                </div>
              </div>
              <div className="ourValueRight-Grid">
                <div
                  className="ourValueCard"
                  style={{ borderRight: "1px solid #DADADA" }}
                >
                  <div className="valueIconContainer">
                    <span className="valueIcon">
                     <IoPeopleSharp />
                    </span>
                    <span className="valueCardTitle">
                      Buyer-Driven Experience
                    </span>
                  </div>
                  <div className="valueCardDesc">
                    Explore freely, show interest only when you're ready, and
                    bid offline with confidence.
                  </div>
                </div>
                <div className="ourValueCard">
                  <div className="valueIconContainer">
                    <span className="valueIcon">
                      <FaRegHandPointRight />
                    </span>
                    <span className="valueCardTitle">
                      Simplicity with Purpose
                    </span>
                  </div>
                  <div className="valueCardDesc">
                    No clutter, no confusion. Just a clear, focused experience
                    to help you decide with confidence.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
